import { Scene } from "phaser";
import { GButton } from "../gameobjects/GButton";
import { transitionScenes } from '../Transition';
import { getCurrentDraw, setLetterSpacing,applyLetterSpacing  } from '../utils';


import { getPastDraws, datetimeToUnixTimestamp  } from '../utils';


export class MenuScene extends Scene {
    constructor() {
        super("MenuScene");
        this.scene
    }

    init() {
        this.cameras.main.fadeIn(200, 0, 0, 0);
        //this.game_over_timeout = 1728897012
        //this.registry.set('drawdate', this.game_over_timeout);
    }

    async requestDevicePermission() {
        if (typeof DeviceMotionEvent.requestPermission === 'function') {
          try {
            const permission = await DeviceMotionEvent.requestPermission();
            if (permission === 'granted') {
              this.setupDeviceOrientation();
            } else {
              console.log("Device motion permission denied");
            }
          } catch (error) {
            console.error("Device motion request failed:", error);
          }
        } else {
          // If no permission needed, proceed
          this.setupDeviceOrientation();
        }
      }

    setupDeviceOrientation() {
        window.addEventListener('deviceorientation', (event) => {
          // Use device orientation data to adjust plane rotation
          // Here, we map alpha, beta, gamma to small rotations on the plane GameObject
          const { alpha, beta, gamma } = event;
      
          // Update rotation values in radians for slight rotation
          // Scaling down the values for a subtle effect
          const xRotation = Phaser.Math.DegToRad(beta * 0.01); // X-axis tilt
          const yRotation = Phaser.Math.DegToRad(gamma * 0.01); // Y-axis tilt
          const zRotation = Phaser.Math.DegToRad(alpha * 0.01); // Z-axis rotation
      
          if (this.scene && this.scene.plane) {
            this.scene.plane.rotation = zRotation;
            this.scene.plane.setAngle(Phaser.Math.RadToDeg(xRotation)); // Adjust x-axis rotation slightly
            this.scene.plane.setAngle(Phaser.Math.RadToDeg(yRotation)); // Adjust y-axis rotation slightly
          }
        });
      }

    async create() {

     


        // // Add the plane GameObject to the scene
        // this.plane = this.add.image(400, 300, 'second-bg');
        // this.plane.setOrigin(0.5, 0.5);

        // // Request device orientation permission
        // this.requestDevicePermission();

        // // Initial orientation setup
        // this.setupDeviceOrientation();


        const add = this.add;
        const myScene = this.scene
        const sWidth = this.scale.width;
        const sHight = this.scale.height;
        const JackpotmaxWidth = 300*2


        const responseCurrent = await getCurrentDraw(this.registry.get('gamecode')); 

        if(responseCurrent.status !== 200){
            // this.scene.start("ErrorScene", {message: "No Player Information"});
            // return;
        }

       

        this.registry.set('my-tickets',responseCurrent.data.tickets);
        this.registry.set('currentDraw', responseCurrent.data);
        this.registry.set('lottery', responseCurrent.data.lottery);

       

        this.currentDrawInfo = this.registry.get('currentDraw') || {};
        this.currentJackPot =  this.formatNumberWithCommas(this.currentDrawInfo?.jackpot_amount || 0)
        //myScene.setActive(true)
        //this.currentDrawInfo = {}

       
        if(this.currentJackPot == 0) {
            this.SecondBG = this.add.image(this.scale.width/2, this.scale.height/2-62, 'no-draw').setOrigin(0.5);
            //this.SecondBG.setScale(0.8)


         

            this.stayTuned = add.text(sWidth/2, sHight/2, 'STAY TUNED',  { fontSize: 160, fontFamily: 'Oswald', color: '#eee', fontWeight:700 }).setOrigin(0.5).setFontStyle("700");
            this.stayTuned.setStroke('#000000',1);

            //const fx1 = this.stayTuned.postFX.addGlow(0x00FFF0, 1, 0, false, 0.1, 50);

            if (this.stayTuned.width > JackpotmaxWidth) {
                // Calculate the scaling factor based on the maxWidth and current width
                const scaleFactor = JackpotmaxWidth / this.stayTuned.width;
                // Apply the scaling factor
                this.stayTuned.setScale(scaleFactor);
            }
            
            this.stayTunedSecond = add.text(sWidth/2, sHight/2 + 120, `FOR THE NEXT EXCITING DRAW!`,{ fontFamily: 'Oswald', fontSize: 48, color: '#ffffff' }).setOrigin(0.5).setFontStyle("400");
            //this.prizeAmountText.setShadow(0,0, '#00FFF0',10 );
            this.stayTunedSecond.setStroke('#000000',3);

            


        }else {
            this.SecondBG = this.add.image(this.scale.width/2, this.scale.height/2-62, 'second-bg').setOrigin(0.5);
            //this.SecondBG.setSize(343*2, 520*2)

         

            // this.prizePool = add.text(sWidth/2, sHight/2-12, 'LOTTERY PRIZE POOL', { fontFamily: 'Oswald', fontSize: 40, color: '#ffffff' }).setOrigin(0.5).setFontStyle("400");
            // this.prizePool.setStroke('#000000',2);

            this.prizePool = this.add.bitmapText(sWidth/2, sHight/2 - 88,  'Oswald-Regular', 'LOTTERY PRIZE POOL', 40).setOrigin(0.5,0);
            // this.prizeAmountText = add.text(sWidth/2, sHight/2 + 120, `$${this.currentJackPot}`, 
            //      { fontSize: 160, fontFamily: 'Oswald', color: '#eee', fontWeight:700,
            //         align: 'center',
            //         // wordWrap: { width:  JackpotmaxWidth, useAdvancedWrap: true }

            //     }).setOrigin(0,0.5).setFontStyle("bold");

            this.prizeAmountText = this.add.bitmapText(sWidth/2, sHight/2 -48,  'oswald2', `$${this.currentJackPot}`, 160);
            //this.prizeAmountText.setShadow(0,0, '#00FFF0',10 );
            //this.prizeAmountText.setStroke('#000000',3);
            //this.prizeAmountText.setDropShadow(4, 4, 0x000000);
            //this.prizeAmountText.postFX.addGradient(0xEEEEEE, 0xEEEEEE, 0.2,0,0,1,1);
            //this.prizeAmountText.postFX.addGradient();
            //this.prizeAmountText.preFX.addShadow(0, 0, 0.006, 4, 0x333333, 10);

            // This is the old glow effect
            //this.prizeAmountText.postFX.addGlow(0xFFD700 , 1, 0, false, 0.5, 16);


            const prizeAmountWidth = this.prizeAmountText.width;

            if (this.prizeAmountText.width > JackpotmaxWidth) {
                // Calculate the scaling factor based on the maxWidth and current width
                const scaleFactor = JackpotmaxWidth / this.prizeAmountText.width;
        
                // Apply the scaling factor
                this.prizeAmountText.setScale(scaleFactor);
                
            }

            const currentMax = prizeAmountWidth > JackpotmaxWidth?JackpotmaxWidth:prizeAmountWidth
            this.prizeAmountText.setPosition(this.scale.width/2 - currentMax/2, this.prizeAmountText.y)

            //this.ShineFx = this.prizeAmountText.postFX.addShine(1, .3, 3);
            //const fx1 = this.prizeAmountText.postFX.addGlow(0x00FFF0, 1, 0, false, 0.1, 50);
        

            if (!this.registry.has("runNumbers")) {
         
                const targetNumber = this.currentDrawInfo?.jackpot_amount || 0

                // Dummy object to hold the counting value
                   const counter = { value: targetNumber/2 };
   
                   const step = 1;                     // The increment step
                   const frameSkip = 3;                  // Update every 2 frames to slow down the display
                   let frameCounter = 0;                 // Counter for frame skipping
   
                   // Create a tween to animate the counter value
                   this.tweens.add({
                       targets: counter,
                       value: targetNumber,           // Target value for the counter
                       duration: 2500,                // Duration in milliseconds
                       ease: 'Cubic.easeOut',         // Easing function
                       onUpdate: () => {
                           // Update the text object with the current counter value (rounded)
                           // Increment the counter by the specified step value
                           //counter.value += step;
   
                           // Only update the text display every `frameSkip` frames
                           frameCounter++;
                           //if (frameCounter >= frameSkip) {
                               this.prizeAmountText.setText("$" + this.formatNumberWithCommas(Math.floor(counter.value)));
   
   
                               if (this.prizeAmountText.width > JackpotmaxWidth) {
                                   // Calculate the scaling factor based on the maxWidth and current width
                                   const scaleFactor = JackpotmaxWidth / this.prizeAmountText.width;
                           
                                   // Apply the scaling factor
                                   //this.prizeAmountText.setScale(scaleFactor);
                                   this.prizeAmountText.setSize(JackpotmaxWidth, JackpotmaxWidth*scaleFactor)
                                   //console.log(Math.floor(this.prizeAmountText.x), this.prizeAmountText.y, this.prizeAmountText.width)
                                   
                                   //this.prizeAmountText.setPosition(this.scale.width , this.scale.height )
   
                               }
                               const currentMax = prizeAmountWidth > JackpotmaxWidth?JackpotmaxWidth:prizeAmountWidth
                               this.prizeAmountText.setPosition(this.scale.width/2 - currentMax/2, this.prizeAmountText.y)
                           //this.prizeAmountText.setPosition(this.prizeAmountText.x - this.prizeAmountText.width/2, sHight/2 + 120 )
   
                             //  frameCounter = 0;       // Reset frame counter
                           //}
                       },
                       onComplete: () => {

                        
                            this.prizeAmountText.setText("$" + this.formatNumberWithCommas(targetNumber));
                            const currentScaleX = this.prizeAmountText.scaleX;
                            const currentScaleY = this.prizeAmountText.scaleY;
                            //this.prizeAmountText.setOrigin(0.5)
                            // this.prizeAmountText.setPosition(this.scale.width/2 , sHight/2 + 240)
                            

                            // Assume `gameObject` is your Phaser GameObject (e.g., a sprite, text, etc.)
                            
                            //this.prizeAmountText.setScale(currentScaleX/2)
                            // // Create a tween to scale the text up with an elastic ease out effect
                            // this.tweens.add({
                            //     targets: this.prizeAmountText,
                            //     scaleX: currentScaleX,         // Target scale for X axis
                            //     scaleY: currentScaleY,         // Target scale for Y axis
                            //     duration: 1500,    // Duration in milliseconds
                            //     ease: 'Elastic.easeOut', // Elastic ease out effect
                            //     easeParams: [1, 0.3],    // Controls the amplitude and period of the elasticity
                            //     onComplete: () => {
                            //         console.log("Tween complete");
                            //     }
                            // });
                        
   
                           // this.tweens.add({
                           //     targets: counter,
                           //     value: targetNumber,           // Target value for the counter
                           //     duration: 3000,                // Duration in milliseconds
                           //     onUpdate: () => {
                           //         // Update the text object with the current counter value (rounded)
                                   
                           //         this.prizeAmountText.setText("$" + this.formatNumberWithCommas(Math.floor(counter.value)));
                           //     },
                           //     onComplete: () => {
                                   //
                               // }
                               
                          // })
                           // Ensure final number is set to target number at the end of the tween
                           
                       }
                   });

        
                // Save the key with a value so this action is not repeated
                this.registry.set("runNumbers", true);
            } 




              
            


        }
        
        this.lotto = this.add.bitmapText(sWidth/2, sHight/2 - 188,  'oswald2',this.currentDrawInfo.lottery.lottery_name.toUpperCase(), 60).setOrigin(0.5,0);
        //this.lotto = add.text(sWidth/2, sHight/2 - 128, this.currentDrawInfo.lottery.lottery_name.toUpperCase(), { fontFamily: 'Oswald', fontSize: 60, color: '#ffffff', fontWeight:700 }).setOrigin(0.5).setFontStyle("bold")
        //this.lotto.setStroke('#000000',1);

        
        const draw_date_realTime = datetimeToUnixTimestamp(this.currentDrawInfo?.draw_date)
        
        var draw_date_unixtime  = draw_date_realTime;
        if(this.currentDrawInfo.status == "closed"){
            const twoMinutesInSeconds = 2 * 60; // 2 minutes in seconds
            draw_date_unixtime += twoMinutesInSeconds
        }
        
       
        this.registry.set('drawdate', draw_date_unixtime);
        
        myScene.launch("TimerScene", { remaining_time: draw_date_unixtime, status: this.currentDrawInfo.status});   

        
        //console.log(" this.SecondBG.y - this.SecondBG.hight/2",  this.SecondBG.y , this.SecondBG)
        const latestResutls = new GButton( this, this.scale.width/2,  this.SecondBG.y - this.SecondBG.height/2 +100, {
            texturePack: "pack", 
            idleTexture: 'Slider-Base.png',
            clickedTexture: 'Button - Secondary - Clicked.png',
            disabledTexture: 'Button - Secondary - Disabled.png',
            icon: {
                image: 'trophy.png',
                scale: 0.75,
                align: 'left'
            },
            text: {
                value:'LATEST RESULTS',
                style:  { fontFamily: 'Montserrat', fontSize: 22, color: '#ffffff' }
            },
            onClick: () => {
                this.scene.stop("MenuScene")
                this.scene.launch("ResultsScene")
             }
        });

        latestResutls.setVisible(false);
        


        //     }
        // })

    // Create button 

    const ButtonMyTickets = new GButton( this, this.scale.width/2 - 180, this.scale.height -106, {
        texturePack: "pack", 
        idleTexture: 'Button - Secondary - Default.png',
        clickedTexture: 'Button - Secondary - Clicked.png',
        disabledTexture: 'Button - Secondary - Disabled.png',
        text: {
            value:'MY TICKETS',
            style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
        },
        onClick: () => {
            //console.log('Button ButtonMyTickets!');
            this.scene.stop("MenuScene")
            this.scene.launch("MyTicketsScene")
         }
    })

    if(this.currentJackPot == 0 ){
        ButtonMyTickets.setDisabled()
    }

    //ButtonMyTickets.setOriginOver(0,0.5);

    //ButtonMyTickets.setScale(1);
    

    this.ButtonBuyTickets = new GButton(this, this.scale.width/2 + 180, this.scale.height - 106, {
        texturePack: "pack", 
        idleTexture: 'Button - Primary - Default.png',
        clickedTexture: 'Button - Primary - Clicked.png',
        disabledTexture: 'Button - Primary - Disabled.png',
        text: {
            value:'BUY TICKET',
            style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
        },
        onClick: () => {
            //console.log('Button ButtonBuyTickets!');
            this.scene.stop("MenuScene")
            this.scene.launch("BuyTicketScene")
         }
    });

    if(this.currentJackPot == 0 || this.currentDrawInfo.status != "open"){
        this.ButtonBuyTickets.setDisabled()
    }
    



        
        const response = await getPastDraws(this.registry.get('gamecode')); 

        if(response.status !== 200){
            this.scene.start("ErrorScene", {message: "No Player Information"});
            return;
        }

        if(response.data.total >0 ){
            latestResutls.setVisible(true);
            this.registry.set('latest_draw', response.data.draw_dates[0].id);
            this.registry.set('past_draws', response.data.draw_dates);
        }



        this.events.on('shutdown', () => {
            //console.log('MenuScene is stopped. Stopping TimerScene...');
            this.scene.stop('TimerScene');  // Stop SceneB when SceneA is stopped
        });



        // Listen for the custom event from Scene A
        this.events.on('DrawEvent', (data) => {
            console.log(data.message); // Outputs: "Hello from Scene A"
            // You can add additional logic here based on the event
            this.scene.start();
        });

        // Listen for the custom event from Scene A
        this.events.on('CloseEvent', (data) => {
            console.log(data.message); // Outputs: "Hello from Scene A"
            this.ButtonBuyTickets.setDisabled()
        });


        this.events.once('shutdown', this.onShutdown, this);

        //  // Check if the 'shutdown' event already has a listener
        //  if (this.events.listenerCount('pause') === 0) {
        //     // In your scene, add an event listener for 'pause' and 'resume'
        //         this.events.on('pause', () => {
        //             this.cameras.main.removePostPipeline('YourPostFXPipeline');
        //             console.log('PostFX removed on pause');
        //         });


        // }

        this.cameras.main.on('prerender', () => {
            if (this.scene.isPaused()) {
                this.cameras.main.postFXActive = false; // Temporarily disable PostFX
                //console.log("this.cameras.main.postFXActive = false;")
            } else {
                this.cameras.main.postFXActive = true; // Re-enable PostFX when the scene is active
                //console.log("this.cameras.main.postFXActive = true;")
            }
        });


        this.events.on('resume', this.onResume, this);
        this.events.on('pause', this.onPause, this);


        // var config = {
        //     image: 'Oswald-700',
        //     width: 36,
        //     height: 62,
        //     //chars: Phaser.GameObjects.RetroFont.TEXT_SET6,
        //     //chars:  " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~",
        //     chars:  "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!№;%:?*()_+-=.,/|\"'@#$^&{}[]",
        //     charsPerRow: 16,
        //     spacing: { x: 0, y: 0 },
        //     lineSpacing: 1,
        // };


        // this.cache.bitmapFont.add('Oswald-700', Phaser.GameObjects.RetroFont.Parse(this, config));


        // // THIS IS THE NEW FONTS
        // this.dynamic1 = this.add.dynamicBitmapText(200, 200, 'oswald2', 'STAY TUNED', 32);
        
        // console.log(" this.dynamic1",  this.dynamic1)

        // this.dynamic1.setDisplayCallback(this.applyLetterSpacing);


        //setLetterSpacing(this.dynamic1, 5); // Add 5px letter spacing

        //this.dynamic = this.add.bitmapText(0, 200, 'Oswald-700', 'STAY TUNED');

    }

    applyLetterSpacing(data){
        // if (data.index >= 5 && data.index <= 8)
        //     {
        //         data.x = Phaser.Math.Between(data.x - 2, data.x + 2);
        //         data.y = Phaser.Math.Between(data.y - 4, data.y + 4);
        //     }
        //console.log(data)
        //if (data.index > 0){
            data.x = data.x + 10 * data.index
        //}

        return data;
    }

    onResume(that) {
        //console.log("resume")
        if(this.prizeAmountText !== undefined){
            //this.ShineFx = this.prizeAmountText.postFX.addShine(1, .3, 3);
        }
        
     
    }

    
    onPause(that) {
        //console.log("pause")
        if(this.prizeAmountText !== undefined){
            //this.prizeAmountText.postFX.remove(this.ShineFx); 
        }
        
     
    }


    update() {

       
    }

    takeSnapshot() {
        // Take a snapshot of the current game renderer
        this.game.renderer.snapshot((image) => {
            // Create a new RenderTexture
            const renderTexture = this.add.renderTexture(400, 300, 800, 600);
            
            // Draw the captured snapshot onto the RenderTexture
            renderTexture.draw(image, 0, 0);
        });
    }

    formatNumberWithCommas(numberString) {
        // Convert the string to a number, then format it with commas
        return parseInt(numberString, 10).toLocaleString();
    }

    datetimeToUnixTimestamp(datetimeString) {
        // Create a Date object from the datetime string
        const date = new Date(datetimeString);
    
        // Get the Unix timestamp in seconds by dividing by 1000
        return Math.floor(date.getTime() / 1000);
    }

    // Ensure you remove the event listener if the scene is stopped or shutdown
    onShutdown() {
        //console.log("Shutdown Menu Scene")
        const sceneB = this.scene.get('TimerScene');
       // sceneB.events.off('myEvent', this.handleEventFromSceneB, this);
        this.events.off('DrawEvent');
        this.events.off('CloseEvent');
    }
    
    // Example usage
    

}